import { useLanguageStore } from '@/helpers/composables/useStores';
import { TitleDetail } from '@/interfaces/title-details-graphql';
import { MaybeRefOrGetter, toValue } from '@vueuse/core';
import { computed } from 'vue';

import adminConfig from '@/features/promotions/config.json';

//useTitleBasedSteering
export function useTitleBasedSteering({ title }: { title: MaybeRefOrGetter<TitleDetail> }) {
	const { country } = useLanguageStore();
	const _title = computed(() => toValue(title));

	// turn Title based steering on/off from config
	const enabled = adminConfig?.steering_overrides_us?.active ?? false;

	const isATVPlusTitle = computed(() => _title.value.offers.some(offer => offer.package.shortName === 'atp'));
	const isHuluTitle = computed(() => _title.value.offers.some(offer => offer.package.shortName === 'hlu'));
	const isPrimeTitle = computed(() => _title.value.offers.some(offer => offer.package.shortName === 'amp'));

	const hasHuluGenre = computed(() =>
		_title.value.content.genres.some(genre => ['drm', 'rly', 'crm', 'rma', 'ani'].includes(genre.shortName))
	);

	// If we pass null, usePromotion retures the config promotion
	const hardcodedShortName = computed(() => {
		if (country.value !== 'US' || !enabled) return null;

		if (isATVPlusTitle.value) return 'atp';

		if (isHuluTitle.value) return 'hlu';
		if (isPrimeTitle.value) return 'amp';

		return hasHuluGenre.value ? 'hlu' : 'amp';
	});

	const hasTitleBasedSteering = computed(() => !!hardcodedShortName.value);

	return {
		hardcodedShortName,
		hasTitleBasedSteering,
	};
}
